import loadModuleOnElement from "../../../utils/loadModuleOnElement";

const loader = () => import("./renderer");
const selector = ".site-avatar-edit";

export default function loadEditLogo(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
